import { StyleSheet } from 'react-native'

/**
 * Generate Styles depending on MetricsSizes vars availabled at ./Theme/Variables
 * Styles are like :
 * <size><direction><op>: {
 *    <op><direction>: <value>
 * }
 * where:
 * <size>: is the key of the variable included in MetricsSizes
 * <direction>: can be ['Bottom','Top','Right','Left','Horizontal','Vertical']
 * <op>: can be ['Margin', 'Padding']
 * <value>: is the value of the <size>
 */

/**
 *
 * @param Theme can be spread like {Colors, NavigationColors, Gutters, Layout, Common, ...args}
 * @return {*}
 */
export default function ({ MetricsSizes }: {MetricsSizes?:any}) {
  return StyleSheet.create({
    ...Object.entries(MetricsSizes).reduce(
      (acc, [key, value]) => ({
        ...acc,
        /* Margins */
        [`${key}Margin`]: {
          marginTop: typeof value === "string"? value: value + "px",
          marginBottom: typeof value === "string"? value: value + "px",
          marginLeft: typeof value === "string"? value: value + "px",
          marginRight: typeof value === "string"? value: value + "px",
        },
        [`${key}BMargin`]: {
          marginBottom: typeof value === "string"? value: value + "px",
        },
        [`${key}TMargin`]: {
          marginTop: typeof value === "string"? value: value + "px",
        },
        [`${key}RMargin`]: {
          marginRight: typeof value === "string"? value: value + "px",
        },
        [`${key}LMargin`]: {
          marginLeft: typeof value === "string"? value: value + "px",
        },
        [`${key}VMargin`]: {
          marginVertical: typeof value === "string"? value: value + "px",
        },
        [`${key}V_Margin`]: {
          marginLeft: typeof value === "string"? value: value + "px",
          marginRight: typeof value === "string"? value: value + "px",
        },
        [`${key}H_Margin`]:{
          marginTop: typeof value === "string"? value: value + "px",
          marginBottom: typeof value === "string"? value: value + "px",
        },
        [`${key}HMargin`]: {
          marginHorizontal: typeof value === "string"? value: value + "px",
        },
        /* Paddings */
        [`${key}Padding`]: {
          paddingTop: typeof value === "string"? value: value + "px",
          paddingBottom: typeof value === "string"? value: value + "px",
          paddingLeft: typeof value === "string"? value: value + "px",
          paddingRight: typeof value === "string"? value: value + "px",
        },
        [`${key}BPadding`]: {
          paddingBottom: typeof value === "string"? value: value + "px",
        },
        [`${key}TPadding`]: {
          paddingTop: typeof value === "string"? value: value + "px",
        },
        [`${key}RPadding`]: {
          paddingRight: typeof value === "string"? value: value + "px",
        },
        [`${key}LPadding`]: {
          paddingLeft: typeof value === "string"? value: value + "px",
        },
        [`${key}VPadding`]: {
          paddingVertical: typeof value === "string"? value: value + "px",
        },
        [`${key}V_Padding`]: {
          paddingLeft: typeof value === "string"? value: value + "px",
          paddingRight: typeof value === "string"? value: value + "px",
        },
        [`${key}H_Padding`]:{
          paddingTop: typeof value === "string"? value: value + "px",
          paddingBottom: typeof value === "string"? value: value + "px",
        },
        [`${key}HPadding`]: {
          paddingHorizontal: typeof value === "string"? value: value + "px",
        },
      }),
      {},
    ),
  })
}
